import { CAMPAIGN_IMAGES } from "../../config/links";

const QUESTIONS = [
  "Why aren't these leads converting?",
  "Am I wasting money?",
  "How long can I keep doing this manually?",
  "What if this month slows down?",
  "Why does growth feel so hard?",
];

export default function EmotionalConnect() {
  return (
    <section
      id="emotional-connect"
      data-testid="emotional-connect-section"
      className="relative py-24 sm:py-32 overflow-hidden border-y border-white/5"
    >
      {/* Cinematic blue darkness */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-[#050e22] via-[#0a1733] to-[#050e22]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[900px] bg-amber-500/[0.04] blur-[140px] rounded-full" aria-hidden />
      </div>

      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* IMAGE — 4AM anxiety */}
          <div className="lg:col-span-6 reveal">
            <div className="relative group">
              <div className="absolute -inset-3 bg-amber-500/10 blur-2xl opacity-60 group-hover:opacity-80 transition-opacity duration-700" aria-hidden />
              <div className="relative overflow-hidden border border-white/10 shadow-[0_30px_80px_rgba(0,0,0,0.6)]">
                <img
                  src={CAMPAIGN_IMAGES.fourAM}
                  alt="The thoughts that wake you up at 4am — am I wasting money, why aren't these leads converting"
                  className="w-full h-auto object-cover"
                />
                {/* Cinematic vignette */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#050e22] via-transparent to-transparent opacity-60 pointer-events-none" />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/5 pointer-events-none" />
              </div>
              <div className="absolute -bottom-3 -left-3 bg-[#050e22] border border-amber-500/30 px-3 py-1.5">
                <span className="font-sans-body uppercase text-[10px] tracking-[0.3em] text-amber-400">
                  4:00 AM
                </span>
              </div>
            </div>
          </div>

          {/* COPY */}
          <div className="lg:col-span-6">
            <div className="reveal flex items-center gap-3 mb-6">
              <span className="h-[1px] w-10 bg-amber-500/70" />
              <span className="font-sans-body uppercase text-[11px] tracking-[0.32em] text-amber-400">
                4 AM Honesty
              </span>
            </div>

            <h2
              data-testid="emotional-headline"
              className="reveal font-display font-light text-white text-3xl sm:text-4xl lg:text-[48px] leading-[1.1] tracking-[-0.01em] text-balance"
              style={{ transitionDelay: "80ms" }}
            >
              Have you ever stared at the ceiling at 4 a.m.{" "}
              <span className="italic text-amber-400">wondering…</span>
            </h2>

            <ul className="mt-8 space-y-3">
              {QUESTIONS.map((q, i) => (
                <li
                  key={q}
                  data-testid={`emotional-question-${i}`}
                  className="reveal flex items-start gap-4 text-base sm:text-lg text-slate-200 leading-relaxed"
                  style={{ transitionDelay: `${140 + i * 70}ms` }}
                >
                  <span className="font-display text-amber-500/80 text-xl leading-none mt-1">
                    "
                  </span>
                  <span className="italic">{q}</span>
                </li>
              ))}
            </ul>

            <div
              className="reveal mt-10 p-6 sm:p-7 bg-amber-500/[0.05] border-l-2 border-amber-500"
              style={{ transitionDelay: "560ms" }}
            >
              <p className="font-display text-xl sm:text-2xl text-white leading-snug">
                You're not alone.
              </p>
              <p className="mt-3 text-slate-300 text-sm sm:text-base leading-relaxed">
                Most advisors and entrepreneurs aren't struggling because
                they lack talent. They're struggling because their systems
                were never designed to scale.
              </p>
              <p className="mt-4 font-display text-lg text-amber-400 italic">
                You are not failing. Your systems are.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
